export default __webpack_public_path__ + "static/media/img-0137-germany-half-face.c4c8ca07.png";